import React from "react"
import { List, Segment } from "semantic-ui-react"
import { injectIntl } from "react-intl"

const Footer = () => {
    const currentYear = new Date().getFullYear()

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerInnerInfo" >
                <div className="footerFirst">
                    <p>Social Media</p>
                    <div>
                        <a className="item socialIcon" href="https://www.facebook.com/bmwbeutler" target="_blank">
                            <i className="ri-facebook-circle-fill"></i>
                        </a>
                        <a className="item socialIcon" href="https://www.instagram.com/bmwbeutler" target="_blank">
                            <i className="ri-instagram-line"></i>
                        </a>
                    </div>
                </div>
                <hr />
                <div className="footerSecond">
                    <List className="footerList">
                        <p className="footerListTitle">Kontakt</p>

                        <a className="item" href="./kontakt">Kontakt</a>
                    </List>

                    <List className="footerList">
                        <p className="footerListTitle">Rechtliches</p>

                        <a className="item" href="./impressum">Impressum</a>

                        <a className="item" href="./datenschutz">Datenschutzerklärung</a>
                    </List>
                </div>

                <div className="footerThird">
                    <div className="item">
                        <i className="ri-copyright-line"></i> {currentYear} Beutler Auto AG
                    </div>
                </div>
            </div>
        </Segment>
    )
}

export default injectIntl(Footer)